import { Injectable } from '@angular/core';
import { NextcloudFile, NextcloudSearchRequest, Setting } from '../classes';
import { BackEndService } from '../backend-service';
import { Observable, throwError } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as globals from "./../globals";
import { TokenService } from '../lib/shared/services/token.service';
import { SessionService } from '../lib/shared/services/session.service';
import { switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
/**
 * @deprecated this file service is deprecated!
 */
export class FileService {

  constructor(
    private _tokenService: TokenService,
    private _backEndServie: BackEndService,
    private _httpClient: HttpClient,
    private _sessionService: SessionService
  ) { }

  createNewFolder(path: string) {
    let auth = new HttpHeaders().set("Authorization", "Bearer " + this._tokenService.token);
    return this._httpClient.request("post", globals.serverLocation + "/api/nextcloud/folder/create", {
      headers: auth,
      body: { "path": path }
    });
  }

  getFileRelativePath(path: string): string {
    let array = path.split("/");
    if (this._backEndServie.nextcloudUsername) {
      let i = array.indexOf(this._backEndServie.nextcloudUsername.stgvalue);
      if (i) return array.slice(i + 1, array.length - 1).join("/");
    } else {
      console.warn("no nextcloud username setted!");
      return array.join("/");
    }
  }

  getFilePrettyRelativePath(path: string): string[] {
    let array = decodeURI(path).split("/");
    if (this._backEndServie.nextcloudUsername) {
      let i = array.indexOf(this._backEndServie.nextcloudUsername.stgvalue);
      if (i) return array.slice(i + 1, array.length - 1);
    } else {
      console.warn("no nextcloud username setted!");
      return array;
    }
  }

  getFileFromNextcloud(file: NextcloudFile): Observable<any> {
    return this.getFileByPath(file.href);
  }

  getFileByPath(path: string): Observable<any> {
    let auth = new HttpHeaders().set("Authorization", "Bearer " + this._tokenService.token);
    return this._httpClient.request("post", globals.serverLocation + "/api/nextcloud/file", {
      headers: auth,
      body: { "path": path, "username": this._backEndServie.nextcloudUsername.stgvalue },
      responseType: "blob"
    });
  }

  getJSONFileByPath(path: string): Observable<any> {
    let auth = new HttpHeaders().set("Authorization", "Bearer " + this._tokenService.token);
    return this._sessionService.getSettingByName(SessionService.globalSettingNames.NEXTCLOUD_USERNAME).pipe(
      switchMap((setting: Setting) => this._httpClient.request("post", globals.serverLocation + "/api/nextcloud/file", {
        headers: auth,
        body: { "path": path, "username": setting.stgvalue }
      }))
    );
  }

  getFolderByPath(path: string): Observable<NextcloudFile[]> {
    if (!path) return throwError('no folderlocation passed');
    let auth = new HttpHeaders().set("Authorization", "Bearer " + this._tokenService.token);
    return this._sessionService.getSettingByName(SessionService.globalSettingNames.NEXTCLOUD_USERNAME).pipe(
      switchMap((setting: Setting) => this._httpClient.request("post", globals.serverLocation + "/api/nextcloud/folder", {
        headers: auth,
        body: { "path": path, "username": setting.stgvalue }
      }) as Observable<NextcloudFile[]>)
    );
  }

  getFolderByPathAndHttpState(path: string): Observable<any> {
    let auth = new HttpHeaders().set("Authorization", "Bearer " + this._tokenService.token);
    return this._sessionService.getSettingByName(SessionService.globalSettingNames.NEXTCLOUD_USERNAME).pipe(
      switchMap((setting: Setting) => this._httpClient.request("post", globals.serverLocation + "/api/nextcloud/folder", {
        observe: "response",
        headers: auth,
        body: { "path": path, "username": setting.stgvalue }
      }))
    );
  }

  removeFileFromNextcloud(file: NextcloudFile): Observable<any> {
    let auth = new HttpHeaders().set("Authorization", "Bearer " + this._tokenService.token);
    return this._httpClient.request("delete", globals.serverLocation + "/api/nextcloud", {
      headers: auth,
      body: { "path": file.href }
    });
  }

  renameFile(oldPath: string, newPath: string) {
    let auth = new HttpHeaders().set("Authorization", "Bearer " + this._tokenService.token);
    return this._httpClient.post(globals.serverLocation + "/api/nextcloud", {
      path: oldPath,
      newPath: newPath
    } as NextcloudSearchRequest, {
      headers: auth
    });
  }

  uploadFile(path: string, data: FormData): Observable<any> {
    if (path) {
      let auth = new HttpHeaders().set("Authorization", "Bearer " + this._tokenService.token).set("Path", path);
      return this._httpClient.put(globals.serverLocation + "/api/nextcloud/file", data, {
        headers: auth
      });
    } else return throwError({});
  }

  static getFileType(type: string): string {
    switch (type) {
      case "image/png":
        type = "png";
        break;
      case "image/jpeg":
        type = "jpg";
        break;
      case "text/plain":
        type = "txt";
        break;
      case "text/html":
        type = "html";
        break;
      case "application/pdf":
        type = "pdf";
        break;
      case "application/json":
        type = "json";
        break;
      case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
        type = "xlsx";
        break;
      case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
        type = "docx";
        break;
      case "application/vnd.ms-excel.sheet.macroenabled.12":
      case "application/vnd.ms-excel.sheet.macroEnabled.12":
        type = "xlsm";
        break;
      case "application/octet-stream":
        type = "blank";
        break;
      case "text/csv":
        type = "csv";
        break;
      case "folder":
        type = "folder";
        break;
      case "video/mp4":
        type = "mp4";
        break;
      default:
        console.warn("unknown file type: " + type);
        break;
    }
    if (type) {
      return "fiv-icon-" + type;
    } else {
      console.log("unknown type: " + type);
      return "fiv-icon-blank";
    }
  }

  static useWithNextcloud(type: string): boolean {
    switch (type) {
      case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
      case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
      case "text/plain":
        return true;
    }
    return false;
  }


  static prettyFileSize(value: string): string {
    var size = parseFloat(value);
    if (size < 1000) return (size).toFixed(0) + " Byte";
    size = size / 1000;
    if (size < 1000) return (size).toFixed(2) + " kB";
    size = size / 1000;
    if (size < 1000) return (size).toFixed(2) + " MB";
    size = size / 1000;
    if (size < 1000) return (size).toFixed(2) + " GB";
    size = size / 1000;
    if (size < 1000) return (size).toFixed(2) + " TB";
    size = size / 1000;
    if (size < 1000) return (size).toFixed(2) + " PB";
    return size.toFixed(2);
  }
}